import { Outlet } from "react-router-dom";

export default function SuppliersPage() {
  return (
  <div> 
      <Outlet/>
  </div>);
}